import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles'

//import the required componenents
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Paper from '@material-ui/core/Paper'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'
import CircularProgress from '@material-ui/core/CircularProgress'
import Fade from '@material-ui/core/Fade'
import GridItem from "../../components/Grid/GridItem";
import Card from '../../components/Card/Card';
import CardBody from "../../components/Card/CardBody";

import Button from "../../components/CustomButtons/Button";
import CustomInput from "../../components/CustomInput/CustomInput";
import logo from '../../assets/img/Logo-new-2021.svg'
import GoogleLogin from '../../assets/img/btn_google_signin_dark_normal_web@2x.png'

import EmailIcon from '@material-ui/icons/Email';
import LockIcon from '@material-ui/icons/Lock';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

import * as actions from '../../store/actions/auth';

import { connect } from 'react-redux'

import Snackbar from "../../components/Snackbar/Snackbar"

import { BACKEND } from "../../constants"

// Import centralized theme
import theme from '../../themes/theme';

const LoginSignup = (props) => {
    const classes = styles();

    const [userEmail, setUserEmail] = useState('');
    const [userPassword, setUserPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const [inputEmailError, setInputEmailError] = useState(false);
    const [inputPasswordError, setInputPasswordError] = useState(false);

    const [isProcessing, setProcessing] = useState(false);

    const [notificationOpen, setNotificationOpen] = useState(false);
    const [notificationColor, setNotificationColor] = useState('success');
    const [notificatonMesssage, setNotificatonMesssage] = useState('');


    useEffect(() => {
        props.refreshAuth();
        //check if i have status
        const queryString = props.location.search;
        if (queryString.length) {
            const parsedQuery = parseQuery(queryString);
            if (parsedQuery.status == 'error') {
                setNotificationColor('danger');
                setNotificatonMesssage(parsedQuery.message)
                setNotificationOpen(true);
                setTimeout(function () {
                    setNotificationOpen(false);
                }, 3000);
            }
            if (parsedQuery.status === 'success') {
                //get the cookie
                const cookies = document.cookie.split('; ').reduce((prev, current) => {
                    const [name, value] = current.split('=');
                    prev[name] = decodeURIComponent(value);
                    return prev
                }, {});
                if (cookies.token && cookies.token.length) {
                    var d = new Date();
                    d.setTime(d.getTime() - (1 * 24 * 60 * 60 * 1000));
                    document.cookie = `token=; expires=${d.toUTCString()}; path=/`;

                    props.refreshToken(cookies.token);
                }
            }
        }
        //refresh the auth
        if (props.auth.authenticated) {
            if (props.auth.token) {
                props.history.push('/');
            }
        }
    }, [props.auth]);

    function parseQuery(queryString) {
        var query = {};
        var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split('=');
            query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
        }
        return query;
    }

    const handleEmailEvent = (event) => {
        setUserEmail(event.target.value);
        setInputEmailError(!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(event.target.value))
    }

    const handlePasswordEvent = (event) => {
        setUserPassword(event.target.value)
        setInputPasswordError(event.target.value.length === 0)
    }

    const attemptSignin = () => {
        setProcessing(true);
        props.signIn({ userEmail, userPassword }, (error, user) => {
            setProcessing(false);

            if (error) {
                setNotificationColor('danger');
                setNotificatonMesssage('Login error. Please check the credentials.')
                setNotificationOpen(true);
                setTimeout(function () {
                    setNotificationOpen(false);
                }, 3000);

                return;
            }
            props.history.push('/dashboard');

        })
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        if (!inputEmailError)
            setInputEmailError(userEmail.length === 0)

        if (!inputPasswordError)
            setInputPasswordError(userPassword.length === 0)

        //if everything is alright then dispatch the request
        if (!inputEmailError && !inputPasswordError && userEmail.length !== 0 && userPassword.length !== 0) {
            attemptSignin();
        }
    }

    return (
        <div className={classes.center}>
            <Snackbar place='tr' color={notificationColor} message={notificatonMesssage} open={notificationOpen} />

            <Fade in={true} timeout={800}>
                <Box className={classes.loginContainer}>
                    <Paper className={classes.loginCard} elevation={24}>
                        {/* Logo Section */}
                        <Box className={classes.logoSection}>
                            <img src={logo} alt="Thinxtra Logo" className={classes.logo} />
                            <Typography variant="h4" className={classes.title}>
                                Soracom Wizard
                            </Typography>
                            <Typography variant="body2" className={classes.subtitle}>
                                Sign in to access your dashboard
                            </Typography>
                        </Box>

                        {/* Login Form */}
                        <Box className={classes.formSection}>
                            <form className={classes.form} noValidate autoComplete="off" onSubmit={handleSubmit}>
                                <Box mb={3}>
                                    <CustomInput
                                        labelText="Email Address"
                                        id="userEmail"
                                        inputProps={{
                                            value: userEmail,
                                            onChange: handleEmailEvent,
                                            error: inputEmailError,
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <EmailIcon style={{ color: theme.components.input.iconColor }} />
                                                </InputAdornment>
                                            ),
                                        }}
                                        formControlProps={{
                                            fullWidth: true,
                                        }}
                                    />
                                    {inputEmailError && (
                                        <Typography variant="caption" color="error" style={{ marginTop: 4, display: 'block' }}>
                                            Please enter a valid email address
                                        </Typography>
                                    )}
                                </Box>

                                <Box mb={3}>
                                    <CustomInput
                                        labelText="Password"
                                        id="password"
                                        formControlProps={{
                                            fullWidth: true,
                                        }}
                                        inputProps={{
                                            type: showPassword ? "text" : "password",
                                            value: userPassword,
                                            onChange: handlePasswordEvent,
                                            error: inputPasswordError,
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <LockIcon style={{ color: theme.components.input.iconColor }} />
                                                </InputAdornment>
                                            ),
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => setShowPassword(!showPassword)}
                                                        edge="end"
                                                        size="small"
                                                    >
                                                        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    {inputPasswordError && (
                                        <Typography variant="caption" color="error" style={{ marginTop: 4, display: 'block' }}>
                                            Password is required
                                        </Typography>
                                    )}
                                </Box>

                                <Button
                                    type="submit"
                                    color="primary"
                                    disabled={isProcessing}
                                    fullWidth
                                    style={{
                                        padding: theme.components.button.padding,
                                        fontSize: theme.typography.fontSize.bodyRegular,
                                        fontWeight: theme.typography.fontWeight.semibold,
                                        marginTop: theme.spacing.sm,
                                    }}
                                >
                                    {isProcessing ? (
                                        <>
                                            <CircularProgress size={20} style={{ color: theme.colors.primary.contrast, marginRight: theme.spacing.sm }} />
                                            Signing in...
                                        </>
                                    ) : (
                                        'Sign In'
                                    )}
                                </Button>
                            </form>

                            {/* Divider */}
                            <Box className={classes.dividerContainer}>
                                <Divider className={classes.divider} />
                                <Typography variant="body2" className={classes.dividerText}>
                                    OR
                                </Typography>
                                <Divider className={classes.divider} />
                            </Box>

                            {/* Google Sign In */}
                            <Box className={classes.googleSection}>
                                <a href={`${BACKEND.BASE}/auth/google`} className={classes.googleLink}>
                                    <Box className={classes.googleButton}>
                                        <img src={GoogleLogin} alt="Sign in with Google" className={classes.googleImage} />
                                    </Box>
                                </a>
                            </Box>
                        </Box>

                        {/* Footer */}
                        <Box className={classes.footer}>
                            <Typography variant="caption" color="textSecondary">
                                © {new Date().getFullYear()} Thinxtra. All rights reserved.
                            </Typography>
                        </Box>
                    </Paper>
                </Box>
            </Fade>
        </div>
    )

}

const styles = makeStyles((muiTheme) => ({
    center: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        width: '100vw',
        backgroundColor: theme.colors.backgrounds.dark,
        backgroundImage: 'url(https://thinxtra.com/wp-content/uploads/Helix_0.svg)',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        padding: theme.spacing.lg,
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: theme.colors.backgrounds.overlay,
            pointerEvents: 'none',
        },
    },
    loginContainer: {
        width: '100%',
        maxWidth: '440px',
        animation: '$slideUp 0.6s ease-out',
        position: 'relative',
        zIndex: 1,
    },
    loginCard: {
        borderRadius: theme.borderRadius.large,
        overflow: 'hidden',
        backgroundColor: theme.colors.neutral.white,
        backdropFilter: 'blur(10px)',
    },
    logoSection: {
        padding: `${theme.spacing['2xl']} ${theme.spacing.xl} ${theme.spacing.xl}`,
        textAlign: 'center',
        background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)',
        borderBottom: `1px solid ${theme.colors.neutral.border}`,
    },
    logo: {
        maxWidth: '180px',
        height: 'auto',
        marginBottom: theme.spacing.lg,
        filter: `drop-shadow(${theme.shadows.small})`,
    },
    title: {
        fontWeight: theme.typography.fontWeight.bold,
        color: theme.colors.neutral.darkText,
        marginBottom: theme.spacing.sm,
        fontSize: theme.typography.fontSize.h3,
    },
    subtitle: {
        color: theme.colors.neutral.mediumText,
        fontSize: '0.95rem',
    },
    formSection: {
        padding: `${theme.spacing.xl} ${theme.spacing.xl} ${theme.spacing.xl}`,
    },
    form: {
        width: '100%',
    },
    dividerContainer: {
        display: 'flex',
        alignItems: 'center',
        margin: `${theme.spacing.xl} 0 ${theme.spacing.lg}`,
    },
    divider: {
        flex: 1,
        backgroundColor: 'rgba(0,0,0,0.08)',
    },
    dividerText: {
        margin: `0 ${theme.spacing.md}`,
        color: theme.colors.neutral.lightText,
        fontWeight: theme.typography.fontWeight.medium,
        fontSize: theme.typography.fontSize.bodySmall,
    },
    googleSection: {
        textAlign: 'center',
    },
    googleLink: {
        textDecoration: 'none',
        display: 'inline-block',
    },
    googleButton: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2px',
        borderRadius: theme.borderRadius.small,
        transition: theme.transitions.button,
        cursor: 'pointer',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: theme.shadows.elevated,
        },
    },
    googleImage: {
        display: 'block',
        maxWidth: '100%',
        height: 'auto',
    },
    footer: {
        padding: `${theme.spacing.lg} ${theme.spacing.xl}`,
        textAlign: 'center',
        borderTop: `1px solid ${theme.colors.neutral.border}`,
        backgroundColor: 'rgba(0,0,0,0.02)',
    },
    '@keyframes slideUp': {
        '0%': {
            opacity: 0,
            transform: 'translateY(40px)',
        },
        '100%': {
            opacity: 1,
            transform: 'translateY(0)',
        },
    },
}));

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps, actions)(LoginSignup);
